import home from './sv/home';
import settings from './sv/settings';
import HomePage from './sv/HomePage';
import MinLivesStilHeader from './sv/MinLivesStilHeader';
import WelcomePage from './sv/WelcomePage';
import LoginPage from './sv/LoginPage';
import goals from './sv/goals';
import navigation from './sv/navigation';

export default {
  home: home,
  settings: settings,
  HomePage: HomePage,
  MinLivesStilHeader: MinLivesStilHeader,
  WelcomePage: WelcomePage,
  LoginPage: LoginPage,
  goals: goals,
  navigation: navigation,
  welcome: `Välkommen!
Kul att du ska testa Bwell-metoden.
Lycka till!`,
  start: 'Sätt igång',
  emailLabel: 'E-post:',
  passwordLabel: 'Lösenord:',
  login: 'Logga in',
  emailRequired: 'Ange din e-postadress.',
  emailInvalid: 'Ogiltigt e-postformat',
  passwordRequired: 'Ange ditt lösenord.',
  invalidCredentialsTitle: 'Ogiltiga inloggningsuppgifter',
  invalidCredentialsMessage:
    'Ingen användare med de inloggningsuppgifterna hittades.',
  noInternetTitle: 'Ingen internetuppkoppling',
  noInternetMessage: 'Det verkar som att du saknar en internetuppkoppling.',
  serverErrorTitle: 'Kunde inte ansluta till servern',
  serverErrorMessage:
    'Kontrollera att du har en internetuppkoppling och försök igen senare',
  unknownErrorTitle: 'Ett okänt fel har uppstått',
  unknownErrorMessage:
    'Försök igen senare. Kontakta supporten om felet kvarstår',
  privacyPolicy: 'Läs vår integritetspolicy',
  forgotPassword: 'Glömt lösenord?',
  PasswordReset: {
    forgotTitle: 'Återställ lösenord',
    forgotDescription: 'Ange din e-postadress så skickar vi en säker länk där du kan välja ett nytt lösenord.',
    sendLink: 'Skicka återställningslänk',
    emailSent: 'Om det finns ett konto med den e-postadressen har vi skickat en återställningslänk. Kontrollera även skräpposten.',
    resetTitle: 'Välj ett nytt lösenord',
    resetDescription: 'Ange e-postadressen för ditt konto och välj ett nytt lösenord.',
    newPassword: 'Nytt lösenord:',
    confirmPassword: 'Bekräfta nytt lösenord:',
    passwordPlaceholder: 'Minst 8 tecken',
    confirmPasswordPlaceholder: 'Upprepa lösenordet',
    passwordRequired: 'Ange ett nytt lösenord.',
    passwordLength: 'Lösenordet måste innehålla minst 8 tecken.',
    confirmationRequired: 'Bekräfta ditt nya lösenord.',
    passwordMismatch: 'Lösenorden matchar inte.',
    savePassword: 'Spara nytt lösenord',
    resetSuccess: 'Ditt lösenord har ändrats. Du kan nu logga in med ditt nya lösenord.',
    loginWithNewPassword: 'Gå till inloggningen',
    invalidOrExpired: 'Återställningslänken är ogiltig eller har gått ut.',
    requestNewLink: 'Begär en ny länk',
    requestError: 'Något gick fel. Kontrollera anslutningen och försök igen.',
    backToLogin: 'Tillbaka till inloggningen',
  },
  workMessage1: 'Bwell ger dig som anställd en personlig Livsstilsplan.',
  workMessage2:
    'Och hjälper dig att bestämma hur du vill ha ditt fysiska, mentala och sociala liv framöver. Sånt som är viktigt för att kunna må bra!',
  featureNotAvailable: 'Det här är inte tillgängligt i denna testversion.'
};
